<template>
  <div class="science-detail">
    <div class="phone">
      <iframe id="detailIframe" class="detailIframe" name="detailIframe" :src="url+'/#/science/picture-word?id='+id+'&os='+os"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: "ScienceDetail",
  data() {
    return {
      url: '',
      id: '',
      os:''
    }
  },
  created() {
    this.url = process.env.H5_GATEWAY_ROOT
    this.id = this.$route.params.id;
    this.os=this.isIOS()?"ios":""

  },
  methods: {
    isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
  }
}
</script>
<style scoped>
.science-detail{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
}
  .science-detail .phone {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  }
  .detailIframe {
     width: 100%;
    height: 100%;
    border: none; 
  }
</style>



// WEBPACK FOOTER //
// src/pages/ScienceDetail.vue